<template>
  <div class="hello">
    <div
      v-if="isFaculty() || isGroupLeader() || isAdmin"
      :class="isAdmin ? 'admin-filters' : ''"
      class="filters md-elevation-4"
    >
      <div class="user-info">
        <div class="user-img big" :style="{'background-image': 'url(\'' + httpEndpoint + user.image + '\')'}">
          <span v-if="!user.image">{{ user && user.firstName && user.firstName[0]
          }}{{ user && user.lastName && user.lastName[0] }}</span>
        </div>
        <div class="user-name">
          {{ user && user.firstName }} {{ user && user.lastName }}
        </div>
        <div class="md-layout-item text-right">
          <assessment-edit
            :create="create"
            @create="$emit('create', $event)"
            :assessment="{}"
            :isNew="true"
            :isAdmin="isAdmin"
          />
        </div>
      </div>
      <div class="md-layout">
        <div v-if="isAdmin" class="md-layout-item p10">
          <ApolloQuery
            ref="users"
            :query="require('../graphql/Users.gql')"
            :variables="{
              offset: 0,
              limit: 0,
              role: 'faculty',
            }"
          >
            <template slot-scope="{ result: { loading, error, data } }">
              <!-- Loading -->
              <div v-if="loading" class="loading apollo">
                <md-field class="md-field-select">
                  <label>Faculty</label>
                  <md-select class="students">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
              </div>

              <!-- Error -->
              <div v-else-if="error" class="error apollo">An error occured</div>

              <!-- Result -->
              <div v-else-if="data" class>
                <!-- <md-autocomplete v-model="student" :value="student" @md-selected="onUserSelect" :md-options="data.users.edges" md-dense>
                <label>Student</label>
                <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.firstName }} {{ item.lastName }}</template>
                </md-autocomplete>-->
                  <md-autocomplete class="students" v-model="filterFaculty" :md-options="getSanitizedFaculties(data.users.edges)" >
                    <label>Faculty</label>
                    <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
                    
                  </md-autocomplete>
              </div>
              <!-- No result -->
              <div v-else class="no-result apollo">
                <md-field class="md-field-select">
                  <label>Faculty</label>
                  <md-select class="students">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
              </div>
            </template>
          </ApolloQuery>
        </div>
        <div class="md-layout-item p10">
          <ApolloQuery
            ref="groups"
            :query="require('../graphql/Groups.gql')"
            :variables="{ offset: 0, limit: 0, filter: { status: 1 } }"
          >
            <template slot-scope="{ result: { loading, error, data } }">
              <!-- Loading -->
              <div v-if="loading" class="loading apollo">
                <md-field class="md-field-select">
                  <label>Group</label>
                  <md-select class="students" v-model="filterGroup">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
              </div>

              <!-- Error -->
              <div v-else-if="error" class="error apollo">An error occured</div>

              <!-- Result -->
              <div v-else-if="data" class="result">
                <md-field class="md-field-select">
                  <label for="group">Group</label>
                  <md-select v-model="filterGroup" name="group" id="group">
                    <md-option value="-">All</md-option>
                    <md-option
                      :key="group.id"
                      v-for="group in data.groups.edges"
                      :value="group.id"
                      >{{ group.label }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <!-- No result -->
              <div v-else class="no-result apollo">
                <md-field class="md-field-select">
                  <label>Group</label>
                  <md-select class="students" v-model="filterGroup">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
              </div>
            </template>
          </ApolloQuery>
        </div>

        <div class="md-layout-item p10">
          <ApolloQuery
            ref="users"
            :query="require('../graphql/Users.gql')"
            :variables="{
              offset: 0,
              limit: 0,
              filter: { group: filterGroup, status: 1, group_status: 1 },
              role: 'student',
            }"
          >
            <template slot-scope="{ result: { loading, error, data } }">
              <!-- Loading -->
              <div v-if="loading" class="loading apollo">
                <md-field class="md-field-select">
                  <label>Student</label>
                  <md-select class="students">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
                
              </div>

              <!-- Error -->
              <div v-else-if="error" class="error apollo">An error occured</div>

              <!-- Result -->
              <div v-else-if="data" class>
                <!-- <md-autocomplete v-model="student" :value="student" @md-selected="onUserSelect" :md-options="data.users.edges" md-dense>
                <label>Student</label>
                <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.firstName }} {{ item.lastName }}</template>
                </md-autocomplete>-->
                <md-autocomplete class="students" v-model="filterStudent" :md-options="getSanitizedFaculties(data.users.edges)" >
                    <label>Student</label>
                    <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
                    
                  </md-autocomplete>
              </div>
              <!-- No result -->
              <div v-else class="no-result apollo">
                <md-field class="md-field-select">
                  <label>Student</label>
                  <md-select class="students">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
              </div>
            </template>
          </ApolloQuery>
        </div>
        <div class="md-layout-item md-xsmall-size-100 p10">
          <ApolloQuery
            ref="users"
            :query="require('../graphql/Templates.gql')"
          >
            <template slot-scope="{ result: { loading, error, data } }">
              <!-- Loading -->
              <div v-if="loading" class="loading apollo">
                <md-field class="md-field-select">
                  <label>>Assessment template</label>
                  <md-select class="students">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
                
              </div>

              <!-- Error -->
              <div v-else-if="error" class="error apollo">An error occured</div>

              <!-- Result -->
              <div v-else-if="data" class>
                <!-- <md-autocomplete v-model="student" :value="student" @md-selected="onUserSelect" :md-options="data.users.edges" md-dense>
                <label>Student</label>
                <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.firstName }} {{ item.lastName }}</template>
                </md-autocomplete>-->
                <md-autocomplete class="students" v-model="filterTemplate" :md-options="getSanitizedTemplates(data.templates.edges)" >
                    <label>Assessment Template</label>
                    <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
                </md-autocomplete>
              </div>
              <!-- No result -->
              <div v-else class="no-result apollo">
                <md-field class="md-field-select">
                  <label>Assessment Template</label>
                  <md-select class="students">
                    <md-option value="-">All</md-option>
                  </md-select>
                </md-field>
              </div>
            </template>
          </ApolloQuery>
        </div>
        <div class="md-layout-item md-xsmall-size-100 p10">
          <md-field class="md-field-select">
            <label for="status">Assessment type</label>
            <md-select class="status" v-model="filterType">
              <md-option value="-">All</md-option>
              <md-option value="daily">Daily</md-option>
              <md-option value="monthly">Monthly</md-option>
              <md-option value="progress">Progress</md-option>
              <md-option value="competency">Competency</md-option>
              <!-- <md-option :key="key" v-for="(status, key) in statuses" :value="status">{{key | capitalize}}</md-option> -->
            </md-select>
          </md-field>
        </div>
        
      </div>
    </div>
    <div v-if="isStudent()" class="filters md-elevation-4">
      <div class="user-info">
        <div class="user-img big">
          {{ user && user.firstName && user.firstName[0]
          }}{{ user && user.lastName && user.lastName[0] }}
        </div>
        <div class="user-name">
          <div class="name-label">
            {{ user && user.firstName }} {{ user && user.lastName }}
          </div>
          <div class="group-label">
            {{ user.group ? user.group.label : "" }}
          </div>
        </div>
        <!-- <div class="chart">
          <apexchart width="150" type="radialBar" :options="chartOptions" :series="chartSeries"></apexchart>
        </div>
        <div class="score">
          <div class="score-label">Average Score</div>
          <div class="score-value">
            <span class="colorized">3/</span>5
          </div>
        </div> -->
      </div>
    </div>
    <div class="md-layout table-label-wrapper">
      <div class="md-layout-item p10 table-label">
        <h1>All Assessments</h1>
      </div>
      <div class="md-layout-item text-right p10 table-status">
        <md-field class="md-field-select no-top-label">
          <label for="status">Status</label>
          <md-select class="status" v-model="filterStatus">
            <md-option value="-">All</md-option>
            <md-option value="draft">In Progress</md-option>
            <md-option value="submitted">Completed</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <!-- Apollo watched Graphql query -->
    <ApolloQuery
      v-show="template"
      ref="assessments"
      @result="onResult"
      :query="query"
      @loading="watchLoading"
      :variables="{
        offset,
        limit,
        order: order,
        direction: orderDirection,
        filter: {
          group: filterGroup,
          status: filterStatusFormated,
          user: filterStudent && filterStudent.id ? filterStudent.id : '-',
          type: filterType,
          faculty: filterFaculty && filterFaculty.id ? filterFaculty.id : '-',
          templateId: filterTemplate && filterTemplate.id ? filterTemplate.id : '-',
          creator_only: true,
        },
      }"
    >
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Loading -->
        <div v-if="loading" class="loading apollo">Loading...</div>

        <!-- Error -->
        <div v-else-if="error" class="error apollo">An error occured</div>

        <!-- Result -->
        <div v-else-if="data" class="result table md-elevation-4">
          <loading :active.sync="isLoading" :is-full-page="false"></loading>
          <table width="100%">
            <thead>
              <tr>
                <th></th>
                <th v-if="isFaculty() || isGroupLeader() || isAdmin">
                  <a
                    :class="{
                      active: order == 'user',
                      desc: direction == true,
                    }"
                    @click="onOrder('user')"
                    href="javascript:void(0);"
                    >Student Name</a
                  >
                </th>
                <th v-if="isFaculty() || isGroupLeader() || isAdmin">
                  Student Type
                </th>
                <th v-else-if="isStudent()">
                  <a
                    :class="{
                      active: order == 'creator',
                      desc: direction == true,
                    }"
                    @click="onOrder('creator')"
                    href="javascript:void(0);"
                    >Faculty Name</a
                  >
                </th>
                <th v-if="isFaculty()">
                  <a
                    :class="{
                      active: order == 'procedure_note',
                      desc: direction == true,
                    }"
                    href="javascript:void(0);"
                    >Procedure Note</a
                  >
                </th>
                <th v-if="isAdmin">
                  <a
                    :class="{
                      active: order == 'creator',
                      desc: direction == true,
                    }"
                    href="javascript:void(0);"
                    >Faculty</a
                  >
                </th>
                <th>
                  <a
                    :class="{
                      active: order == 'type',
                      desc: direction == true,
                    }"
                    @click="onOrder('type')"
                    href="javascript:void(0);"
                    >Type</a
                  >
                </th>
                <th>
                  <a
                    :class="{
                      active: order == 'template',
                      desc: direction == true,
                    }"
                    @click="onOrder('template')"
                    href="javascript:void(0);"
                    >Assessment Template</a
                  >
                </th>
                <th>
                  <a
                    :class="{
                      active: order == 'startDate',
                      desc: direction == true,
                    }"
                    @click="onOrder('startDate')"
                    href="javascript:void(0);"
                    >Start Date</a
                  >
                </th>
                <th>
                  <a
                    :class="{
                      active: order == 'score',
                      desc: direction == true,
                    }"
                    href="javascript:void(0);"
                    >Score</a
                  >
                </th>
                <th>
                  <a
                    :class="{
                      active: order == 'status',
                      desc: direction == true,
                    }"
                    @click="onOrder('status')"
                    href="javascript:void(0);"
                    >Status</a
                  >
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                :key="submission.id"
                v-for="submission in data.submissions.edges"
              >
                <td>
                  <div class="user-img" :style="{'background-image': 'url(\'' + httpEndpoint + submission.user.image + '\')'}">
                    <span v-if="!submission.user.image">{{
                      submission.user &&
                      submission.user.firstName &&
                      submission.user.firstName[0]
                    }}{{
                      submission.user &&
                      submission.user.lastName &&
                      submission.user.lastName[0]
                    }}</span>
                  </div>
                </td>
                <td v-if="isFaculty() || isGroupLeader() || isAdmin">
                  {{ submission.user && submission.user.firstName }}
                  {{ submission.user && submission.user.lastName }}
                </td>
                <td v-if="isFaculty() || isGroupLeader() || isAdmin">
                  {{ submission.user && submission.user.resident ? 'Resident' : 'Student' }}
                </td>
                <td v-if="isStudent()">
                  {{
                    submission.assessment.creator &&
                    submission.assessment.creator.firstName
                  }}
                  {{
                    submission.assessment.creator &&
                    submission.assessment.creator.lastName
                  }}
                </td>
                <td class="procedural" v-if="isFaculty()">
                  {{ submission.procedure_note }}
                </td>
                <td class="faculty" v-if="isAdmin">
                  {{ submission.assessment.creator.firstName }}
                  {{ submission.assessment.creator.lastName }}
                </td>
                <td>{{ submission.assessment.type | capitalize }}</td>
                <td>{{ submission.assessment.template && submission.assessment.template.label | capitalize }}</td>
                <td v-if="submission.assessment.type == 'daily'">
                  {{
                    $moment(parseInt(submission.assessment.startDate))
                      .utc()
                      .format("MM/DD/YYYY")
                  }}
                  {{ submission.assessment.startTime.toUpperCase() }}
                </td>
                <td v-else-if="submission.assessment.type == 'monthly'">
                  {{
                    $moment(parseInt(submission.assessment.startDate))
                      .utc()
                      .format("MMM YYYY")
                  }}
                </td>
                <td v-else>
                  {{
                    $moment(parseInt(submission.assessment.startDate))
                      .utc()
                      .format("MM/DD/YYYY")
                  }}
                </td>
                <td :class="getScore(submission, true)">{{ calculateGrade(submission) }}</td>
                <td>
                  {{
                    submission.status == "submitted"
                      ? "Complete"
                      : "In progress"
                  }}
                </td>
                <td class="controll">
                  <assessment-edit
                    :assessment="submission.assessment"
                    :submission="submission"
                    :user="submission.user"
                    :isAdmin="isAdmin"
                    @refresh-assessments="onUpdateQuery"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <paginator
            @prev="onPrev"
            @next="onNext"
            :page="page"
            :pages="pages"
            :limit="limit"
            :count="count"
            :total="totalCount"
          />
        </div>
        <!-- No result -->
        <div v-else class="no-result apollo">
          <loading :active="true" :is-full-page="false"></loading>
        </div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import Paginator from "./Paginator";
import UserStatuses from "../helpers/UserStatuses";
import AssessmentEdit from "./AssessmentEdit";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import RoleMixinVue from "./RoleMixin.vue";

export default {
  name: "Assesments",
  mixins: [RoleMixinVue],
  props: ["user", "isAdmin", "create"],
  mounted() {
    this.$apollo
      .query({
        query: require("../graphql/Templates.gql"),
        fetchPolicy: "no-cache",
      })
      .then((data) => {
        let templates = {};
        let parseTemplate = (template) => {
          templates[template.id] = template;
          if (template.childrens) {
            template.childrens.forEach((el) => {
              parseTemplate(el);
            });
          }
        };
        data.data.templates.edges.forEach((el) => {
          parseTemplate(el);
        });
        data.data.templates.edges;
        this.template = true;
        this.templates = templates;
        this.templateTree = data.data.templates.edges;
      });
    setTimeout(() => {
      if (this.$refs["groups"] && this.$refs["groups"].$apollo) {
        this.$refs["groups"].$apollo.queries.query.refetch();
      }
    }, 200);
  },
  activated: function () {
    if (this.$refs["assessments"] && this.$refs["assessments"].$apollo) {
      this.$refs["assessments"].$apollo.queries.query.refetch();
    }
  },
  computed: {
    pages() {
      return Math.ceil(this.totalCount / this.limit) - 1;
    },
    offset() {
      return this.page * this.limit;
    },
    orderDirection() {
      return this.direction ? "DESC" : "ASC";
    },
    filterStatusFormated() {
      return this.filterStatus === "-" ? null : this.filterStatus;
    },
  },
  data() {
    return {
      httpEndpoint: location.host == 'localhost:8080' ? 'http://localhost:3000' : '',
      isLoading: false,
      templateTree: {},
      template: false,
      templates: {},
      chartOptions: {
        chart: {
          type: "radialBar",
        },
        colors: ["#5E35B1"],
        plotOptions: {
          radialBar: {
            hollow: {
              size: "50%",
            },
            dataLabels: {
              show: true,
              name: {
                show: false,
              },
              value: {
                show: false,
              },
              total: {
                show: false,
              },
            },
          },
        },
        labels: [""],
      },
      chartSeries: [70],
      page: 0,
      limit: 10,
      totalCount: 0,
      count: 0,
      query: require("../graphql/Submissions.gql"),
      order: "startDate",
      direction: 1,
      filterGroup: "-",
      filterStatus: "-",
      filterStudent: {id:'-', name: '', toLowerCase:()=>{return ''}, toString:()=>{return ''}},
      filterFaculty: {id:'-', name: '', toLowerCase:()=>{return ''}, toString:()=>{return ''}},
      filterTemplate: {id:'-', name: '', toLowerCase:()=>{return ''}, toString:()=>{return ''}},
      filterType: "-",
      statuses: {
        "in progress": 1,
        completed: 2,
      },
    };
  },
  components: {
    Paginator,
    AssessmentEdit,
    Loading,
  },
  methods: {
    getSanitizedTemplates(options) {
      return options.map(item => ({
        'id': item.id,
        'name': item.label,
        'toLowerCase': () => item.label.toLowerCase(),
        'toString': () => item.label
      }));
    },
    getSanitizedFaculties(options) {
      return options.map(item => ({
        'id': item.id,
        'name': item.firstName + ' ' + item.lastName,
        'toLowerCase': () => (item.firstName + ' ' + item.lastName).toLowerCase(),
        'toString': () => item.firstName + ' ' + item.lastName
      }));
    },
    watchLoading(isLoading) {
      this.isLoading = isLoading;
    },
    onPrev() {
      if (this.page > 0) {
        this.page--;
      }
    },
    onNext() {
      if (this.page < this.pages) {
        this.page++;
      }
    },
    onResult(data) {
      this.isLoading = false;
      let totalCount = data.data.submissions.count;
      this.totalCount = totalCount;
      this.count = data.data.submissions.edges.length;
    },
    onUpdateQuery() {
      this.$refs["assessments"].$apollo.queries.query.refetch();
    },
    onOrder(field) {
      if (this.order == field) {
        this.direction = !this.direction;
      } else {
        this.direction = 0;
        this.order = field;
      }
    },
    getStatusLabel(id) {
      return UserStatuses.getKeyByValue(id);
    },
    // param calculateGrade(submission)
    getScore(sub, score_class) {
      let type = 'total';
      
        if (!sub) {
          sub = this.getLastSubmission();
        }
        if (!sub) {
          return 'N/A';
        }
        
        let grading = sub.assessment.template && sub.assessment.template.grading ? sub.assessment.template.grading.label : null;
        let data;
        data = sub.submissionDatas.map(e=>e);
        if (grading && (grading == 'A / I / U ' || grading == 'Pass / Fail')) {
          
          let u = data.filter(e=>e.status&&e.grade == 0);
          if(u && u.length != 0) {
            if (score_class) {
              return 'failure';
            }
            return 'Fail';
          }
          else {
            if (score_class) {
              return 'excellent';
            }
            return 'Pass';
          }
        }
        if (grading && grading == '0 / 2 / 3 / 4') {
          let u = data.filter(e=>e.status&&e.grade == 0);
          if(u && u.length != 0) {
            if (score_class) {
              return 'failure';
            }
            return 0;
          }
          else {
            let v = data.filter(e=>e.status).map(e=>e.grade);
            let avg = function avg(array) {
              let sum = 0;
              for (let i = 0; i < array.length; i++) {
                  sum += array[i];
              }
              if (array.length == 0) {
                return 'N/A'
              }
              return (sum / array.length).toFixed(2)
            }
            let avg_score = avg(v);
            if (score_class) {
              if (avg_score < 2) {
                return 'failure';
              }
              if (avg_score > 2 && avg_score < 3) {
                return 'satisfactory';
              }
              if (avg_score > 3) {
                return 'excellent';
              }
            }
            return avg_score;
          }
        }
      
    },
    calculateGrade(submission) {
      
      if (submission) {
        return this.getScore(submission);
      }
      return "N/A";
      // const arrAvg = (arr) => arr.reduce((a, b) => a + b, 0) / arr.length;
      // let grade = 0;
      // let templates = {};
      // let templateTree = {};
      // if (submission.assessment.type == "daily") {
      //   return "N/A";
      // }
      // if (submission.assessment.type == "monthly") {
      //   submission.relatedSubmissions.edges &&
      //     submission.relatedSubmissions.edges.forEach((sub) => {
      //       sub.submissionDatas.forEach((data) => {
      //         if (data.template && data.template.id) {
      //           if (!templates[data.template.id]) {
      //             templates[data.template.id] = [];
      //           }
      //           templates[data.template.id].push({
      //             grade: data.grade,
      //             status: data.status,
      //             weight: data.template.weight,
      //           });
      //         }
      //       });
      //     });
      // }

      // this.templateTree.forEach((type) => {
      //   type.childrens.forEach((temp) => {
      //     let domain = temp.weight;
      //     templateTree[domain] = {};
      //     if (temp.childrens.length) {
      //       temp.childrens.forEach((t) => {
      //         templateTree[domain][t.id] = templates[t.id];
      //       });
      //     } else {
      //       templateTree[domain][temp.id] = templates[temp.id];
      //     }
      //   });
      // });

      // let finalTemplateTree = {};
      // let corrector = 0;
      // let applyRulesForDomain = (
      //   domain,
      //   minVal,
      //   maxVal,
      //   countVal,
      //   finalDeduction,
      //   skipStatus
      // ) => {
      //   if (skipStatus == undefined) {
      //     skipStatus = false;
      //   }
      //   let domian_avg = {};
      //   finalTemplateTree[domain] = null;
      //   for (let subset in templateTree[domain]) {
      //     let counter = 0;
      //     let avg = 0;
      //     let count0 = 0;
      //     for (let grade in templateTree[domain][subset]) {
      //       let g = templateTree[domain][subset][grade];
      //       if (
      //         g &&
      //         ((skipStatus === false && g.status == true) ||
      //           skipStatus === true)
      //       ) {
      //         counter++;
      //         let grade_value = g.grade;
      //         if (g.grade == 0 || g.grade === null || g.grade === undefined) {
      //           count0++;
      //           grade_value = 0;
      //         }
      //         avg += parseFloat(grade_value);
      //       }
      //     }
      //     if (count0 >= countVal && minVal) {
      //       avg = minVal;
      //       corrector += finalDeduction;
      //     } else {
      //       if (avg && counter) {
      //         avg = avg / counter;
      //         if (maxVal && maxVal > avg) {
      //           avg = maxVal;
      //         }
      //       }
      //     }
      //     domian_avg[subset] = avg;
      //   }
      //   finalTemplateTree[domain] = domian_avg;
      // };
      // let applyRulesForDomain5 = () => {
      //   let domain = 5;
      //   let domian_avg = {};
      //   finalTemplateTree[domain] = null;
      //   for (let subset in templateTree[domain]) {
      //     let counter = 0;
      //     let avg = 0;
      //     let count0 = 0;
      //     for (let grade in templateTree[domain][subset]) {
      //       let g = templateTree[domain][subset][grade];
      //       if (g && g.status == true) {
      //         counter++;
      //         let grade_value = g.grade;
      //         if (g.grade == 0 || g.grade === null || g.grade === undefined) {
      //           count0++;
      //           grade_value = 0;
      //         }
      //         avg += parseFloat(grade_value);
      //       }
      //     }
      //     if (count0 >= 2 && 1) {
      //       avg = 1;
      //       corrector += -0.5;
      //     } else if (count0 == 1) {
      //       if (avg && counter) {
      //         avg = avg / counter;
      //         if (2.4 > avg) {
      //           avg = 2.4;
      //         }
      //       }
      //     } else {
      //       if (avg && counter) {
      //         avg = avg / counter;
      //       }
      //     }
      //     domian_avg[subset] = avg;
      //   }
      //   finalTemplateTree[domain] = domian_avg;
      // };
      // let applyRulesForDomain6 = () => {
      //   let count0 = 0;
      //   let avg_a = [];
      //   let avg_b = [];
      //   let avg_c = [];
      //   let avg_d = [];
      //   for (let temp in templateTree[6]) {
      //     for (let grade in templateTree[6][temp]) {
      //       //ethic = waight = 1
      //       if (
      //         templateTree[6][temp][grade].weight == 1 &&
      //         templateTree[6][temp][grade].status
      //       ) {
      //         avg_a.push(templateTree[6][temp][grade].grade);
      //       }
      //       if (
      //         templateTree[6][temp][grade].weight == 2 &&
      //         templateTree[6][temp][grade].status
      //       ) {
      //         avg_b.push(templateTree[6][temp][grade].grade);
      //       }
      //       if (
      //         templateTree[6][temp][grade].weight == 3 &&
      //         templateTree[6][temp][grade].status
      //       ) {
      //         avg_c.push(templateTree[6][temp][grade].grade);
      //       }
      //       if (
      //         templateTree[6][temp][grade].weight == 4 &&
      //         templateTree[6][temp][grade].status
      //       ) {
      //         avg_d.push(templateTree[6][temp].grade);
      //       }
      //     }
      //   }
      //   let domainFail = false;
      //   avg_a.forEach((el) => {
      //     if (el == 0) count0++;
      //   });
      //   if (count0 >= 1) {
      //     avg_a = [0];
      //     domainFail = true;
      //     corrector += -0.5;
      //   }
      //   if (!domainFail) {
      //     let count0 = 0;
      //     avg_d.forEach((el) => {
      //       if (el == 0) count0++;
      //     });
      //     if (count0 >= 1) {
      //       avg_d = [0];
      //       domainFail = true;
      //       corrector += -0.5;
      //     }
      //   }
      //   if (!domainFail) {
      //     let count0 = 0;
      //     avg_b.forEach((el) => {
      //       if (el == 0) count0++;
      //     });
      //     if (count0 >= 2) {
      //       avg_b = [0];
      //       domainFail = true;
      //       corrector += -0.5;
      //     }
      //   }
      //   if (!domainFail) {
      //     let count0 = 0;
      //     avg_c.forEach((el) => {
      //       if (el == 0) count0++;
      //     });
      //     if (count0 >= 2) {
      //       avg_c = [0];
      //       domainFail = true;
      //       corrector += -0.5;
      //     }
      //   }
      //   if (count0 >= 1) {
      //     avg_d = [0];
      //     corrector += -0.5;
      //   }

      //   //if avarage <= 2.5 fail;
      //   avg_a = avg_a ? arrAvg(avg_a) : 0;
      //   avg_b = avg_b ? arrAvg(avg_b) : 0;
      //   avg_c = avg_c ? arrAvg(avg_c) : 0;
      //   avg_d = avg_d ? arrAvg(avg_d) : 0;
      //   if (avg_a <= 2.5 || avg_b <= 2.5 || avg_c <= 2.5 || avg_d <= 2.5) {
      //     domainFail = true;
      //     finalTemplateTree[6] = { 0: 0 };
      //   }
      //   if (!domainFail) {
      //     finalTemplateTree[6] = { 0: 0 };
      //     finalTemplateTree[6][0] = arrAvg([avg_a, avg_b, avg_c, avg_d]);
      //     if (finalTemplateTree[6][0] <= 2.5) {
      //       finalTemplateTree[6] = { 0: 0 };
      //     }
      //   }
      //   return domainFail;
      // };
      // let applyRulesForDomain7 = () => {
      //   let avg = {};
      //   for (let temp in templateTree[7]) {
      //     for (let grade in templateTree[7][temp]) {
      //       //ethic = waight = 1
      //       avg[templateTree[7][temp][grade].weight] = [];
      //       if (templateTree[7][temp][grade].status) {
      //         avg[templateTree[7][temp][grade].weight].push(
      //           templateTree[7][temp][grade]
      //         );
      //       }
      //     }
      //   }
      //   let domainFail = false;
      //   Object.keys(avg).forEach((key) => {
      //     let count0 = 0;
      //     avg[key].forEach((el) => {
      //       if (el == 0) {
      //         count0++;
      //       }
      //     });
      //     if (!domainFail && count0 >= 2) {
      //       domainFail = true;
      //       corrector += -0.5;
      //     }
      //   });
      //   return domainFail;
      // };
      // for (let i = 1; i <= 3; i++) {
      //   applyRulesForDomain(i, 1, null, 2, -0.5, true);
      // }
      // applyRulesForDomain(4, 1, null, 2, 0);
      // applyRulesForDomain5();

      // let avg_calc_domain = {};
      // for (let domain in finalTemplateTree) {
      //   let avg_calc = [];
      //   let grade = 0;
      //   for (let subset in finalTemplateTree[domain]) {
      //     avg_calc.push(finalTemplateTree[domain][subset]);
      //   }

      //   grade = arrAvg(avg_calc);
      //   avg_calc_domain[domain] = grade;
      // }
      // let count0 = 0;
      // let avg_calc = [];
      // for (let domain in avg_calc_domain) {
      //   if (avg_calc_domain[domain] == 0) {
      //     count0++;
      //   }
      //   avg_calc.push(avg_calc_domain[domain]);
      // }
      // let grade_avg = arrAvg(avg_calc);
      // if (applyRulesForDomain6()) {
      //   count0++;
      // }
      // if (applyRulesForDomain7()) {
      //   count0++;
      // }
      // grade = grade_avg + corrector;

      // if (grade < 1) {
      //   grade = 1;
      // }
      // if (count0 > 2 && grade > 2.4) {
      //   grade = 2.4;
      // }
      // return grade.toFixed(2);
    },
  },
  watch: {
    order() {
      this.isLoading = true;
    },
    orderDirection() {
      this.isLoading = true;
    },
    page() {
      this.isLoading = true;
    },
    filterGroup() {
      this.page = 0;
      this.isLoading = true;
    },
    filterStatus() {
      this.page = 0;
      this.isLoading = true;
    },
    filterStudent() {
      this.page = 0;
      this.isLoading = true;
    },
    filterFaculty() {
      this.page = 0;
      this.isLoading = true;
    },
    filterType() {
      this.page = 0;
      this.isLoading = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  display: flex;
  justify-items: center;
  align-items: center;
  padding: 8px 0px 16px;
  border-bottom: 1px solid #d8d8d8;
  &:last-child {
    border-bottom: none;
  }
  .chart {
    margin-left: auto;
  }
  .user-name {
    margin-left: 10px;
    color: #242424;
    font-size: 18px;
    font-weight: 800;
    line-height: 10px;
    .name-label {
      padding: 5px 0;
    }
    .group-label {
      color: #242424;
      font-size: 14px;
      line-height: 10px;
      font-weight: 300;
      padding: 5px 0;
    }
  }
}
.filters {
  .md-layout-item {
    &.add-assessment {
      padding-top: 32px;
      min-width: 220px;
    }
    min-width: 220px;
  }
}
.score {
  margin-left: -20px;
  margin-right: 10px;
  .score-label {
    color: #333333;
    font-size: 14px;
    font-weight: 800;
    line-height: 24px;
  }
  .score-value {
    color: #8a8a8a;
    font-size: 18px;
    font-weight: 800;
    line-height: 24px;
    .colorized {
      color: #512da8;
    }
  }
}
.procedural {
  white-space: nowrap;
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>